import React, { createContext, useState } from 'react'

const Context = createContext()

export const Provider = ({ children }) => {
    const [globalState, setGlobalState] = useState({
        uploadMode: '',
        selectedFile: null,
        match: null,
        topMatches: [],
        drawerOpen: false,
        showModal: false,
        showSettings: false,
        library: [],
        isMatchLoading: false,
        timeTaken: null,
        librarySize: null,
        devMode: false,
        limit: 10000,
        progressUpdate: null,
        activeFilter: 'fabric'
    })

    return (
        <Context.Provider value={{ globalState, setGlobalState }}>
            {children}
        </Context.Provider>
    )
}

export const useContext = () => {
    return React.useContext(Context)
}
